import React, { FC } from 'react'
import { Icons, ICONS, IconType } from './icons'

type IconProps = {
  icon: IconType | Icons
  size?: number
  width?: number
  height?: number
  color?: string
  stroke?: string
  strokeWidth?: string
  viewBox?: string
  transForm?: string
  className?: string
  onClick?: () => void
  lineBreak?: boolean
  centered?: boolean
  bothCentered?: boolean
  inactive?: boolean
  style?: React.CSSProperties
}

const Icon: FC<IconProps> = props => {
  const {
    icon: propsIcon,
    size,
    width,
    height,
    color,
    stroke,
    strokeWidth,
    viewBox,
    className,
    lineBreak,
    centered,
    bothCentered,
    onClick,
    inactive,
    style,
  } = props

  const styles = {
    svg: {
      display: lineBreak ? 'block' : 'inline-block',
      margin: centered ? '0 auto' : bothCentered ? 'auto auto' : 'initial',
      verticalAlign: 'middle',
      padding: 1,
    },
    path: {
      fill: color,
      stroke: stroke,
    },
    primary: {
      fill: '#ff5689',
    },
    secondary: {
      fill: '#e687ff',
    },
    opacity: {
      opacity: '0.2',
      fill: '#e687ff',
    },
  }

  const icon: IconType =
    typeof propsIcon === 'string' ? ICONS[propsIcon] : propsIcon
  const iconPaths = icon.paths

  return icon ? (
    <div
      onClick={() => {
        onClick && onClick()
      }}
      style={{
        display: 'inline-block',
        ...style,
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <svg
        className={className}
        style={styles.svg}
        width={`${size ? size : width ? width : 23}px`}
        height={`${size ? size : height ? height : 23}px`}
        viewBox={
          viewBox ? viewBox : icon.viewBox ? icon.viewBox : '0 0 1024 1024'
        }
        strokeWidth={strokeWidth ? strokeWidth : ''}
      >
        <g transform={icon.transform}>
          {iconPaths.map((path, index) => {
            const pathStyles = { ...styles.path, ...path.style }
            const inactivePathColor = { fill: '#fff' }
            return (
              <path
                key={index}
                style={
                  inactive
                    ? inactivePathColor
                    : path.style
                    ? pathStyles
                    : styles.path
                }
                d={path.d}
                transform={path && path.transform}
                className={path && path.className}
              />
            )
          })}
        </g>
      </svg>
    </div>
  ) : null
}

export default Icon
